import QueryReTable from "../../components/QueryReTable";
import { useUserServices } from "../../context/DealerProfile";
import useQueryTable from "../../hooks/useQueryTable";
import CancelOrderForm from "./CancelOrderForm";
import CancelOrderListComponent from "./CancelOrderListComponent";

const CancelOrderList = () => {
  const {
    dealerDetail: { accountName, isChannelPartner, dealerName },
  } = useUserServices();

  const [isLoading, data, searchValues, setSearchValues, moreData, totalData] =
    useQueryTable({
      queryList: ["page", "Stage"],
      url: `/server/dealer_backend/${
        isChannelPartner ? "cancel-order" : "cancel-order-customer"
      }/${isChannelPartner ? accountName?.id : dealerName?.id}`,
    });

  const {
    data: { data: cancelOrderData },
  } = data ?? { data: { data: [] } };
  // console.log({ cancelOrderData });

  return (
    <QueryReTable
      heading={"Cancel Requests"}
      headingNeed={true}
      moreData={moreData}
      buttonNeed={true}
      buttonText="Select Order To Cancel"
      buttonNavigation="/order-history"
      searchValues={searchValues}
      setSearchValues={setSearchValues}
      totalData={totalData}
    >
      <CancelOrderForm />
      <CancelOrderListComponent
        isLoading={isLoading}
        cancelOrder={cancelOrderData}
        setSearchValues={setSearchValues}
      />
    </QueryReTable>
  );
};

export default CancelOrderList;
